export const PROVISIONING_CHECK_STATUS = {
  PENDING: 'pending',
  COMPLETE: 'complete',
  ERROR: 'error',
} as const

export type ProvisioningCheckStatus = typeof PROVISIONING_CHECK_STATUS[keyof typeof PROVISIONING_CHECK_STATUS]

export const PROVISIONING_OVERALL_STATUS = {
  READY_FOR_TRAFFIC: 'ready_for_traffic',
  PENDING: 'pending',
  ERROR: 'error',
} as const

export type ProvisioningOverallStatus = typeof PROVISIONING_OVERALL_STATUS[keyof typeof PROVISIONING_OVERALL_STATUS]
